import { Environment } from 'src/app/core/models/security';
import pkg from '../../package.json';

export const environment: Environment = {
  production: true,
  apiBaseUrl: 'https://myhub-gw.curro.co.za/gateway-api',
  synergyApiBaseUrl: 'https://myhub-gw.curro.co.za/gateway-api/synergy-api',
  appVersion: pkg.version + '-prod',
  sentryEnvironment: 'Production',
  sentryRelease: 'MR-1327_Added_Sentry_Error_Reporting',
  sentryDsn: 'https://832317c0ff10b1f10b12855633d975a0@o457085.ingest.sentry.io/4510272025460736',
  sampleRate: 0.25,
  sentryEnabled: true,
  security: {
    tokenEncryptionKey: '5f7d9b3a1c6e8d0f2b4a6c8e0f1a3b5c', // 32 chars - replace via CI/CD
    encryptionSalt: 'ffeeddccbbaa00998877665544332211', // 32 chars - replace via CI/CD
    tokenExpirationTime: 3600, // 1 hour in seconds
    refreshTokenExpirationTime: 604800, // 7 days in seconds
    maxLoginAttempts: 5,
    loginAttemptsWindow: 300, // 5 minutes in seconds
    recaptchaSiteKey: '6LdGj-0rAAAAAOzG_MA4qX35l543XwNNcl9rI_yf', // Your reCAPTCHA site key
    hmacSecret: 'f5PShBZakE0LT9ywO9vjtTCeQlKGblDqHFqE4YZi2j4', // HMAC secret - replace via CI/CD
    lockoutDurationMillis: 5 * 60 * 1000, // 5 minutes in milliseconds
    maxFailedAttempts: 5,
  },
  enrolmentAlumniUrl: 'https://enrolment2alumni-apply.curro.co.za/login',
  updateConfig: {
    checkInterval: 30 * 60 * 1000, // 30 minutes
    forceUpdateDelay: 24 * 60 * 60 * 1000, // 24 hours
    storeUrls: {
      ios: 'https://apps.apple.com/za/app/curro-myhub-2/id6754881300',
      android: 'https://play.google.com/store/apps/details?id=curro.myhub.parent',
    },
  },
  capacitorServerUrl: 'https://myhub-new.curro.co.za',
  shopLinks: {
    grit: 'https://curro.gritprocurement.co.za/curroauth',
    snapplify: 'https://engage.snapplify.com',
    itsi: 'https://curro.store.it.si/za/api/1.0/alchemies/remote/curro/auth',
    itsiWebsite: 'https://store.it.si/za/login',
  },
  features: {
    library: false,
    debitOrders: false,
  },
};
